module.exports = __webpack_public_path__ + "static/img/s3.e041054.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/s3.png
// module id = ugqe
// module chunks = 1